import { Link, useLocation } from "react-router-dom";
import { Calculator, Home, MessageCircle, PiggyBank, Shield, Wallet } from "lucide-react";

const TABS = [
  { to: "/app", label: "Home", icon: Home, testId: "mobile-nav-home", match: (p) => p === "/app" },
  { to: "/app/net-worth", label: "Wealth", icon: Wallet, testId: "mobile-nav-net-worth" },
  { to: "/app/budget", label: "Budget", icon: PiggyBank, testId: "mobile-nav-budget" },
  { to: "/app/policies", label: "Policy", icon: Shield, testId: "mobile-nav-policies" },
  { to: "/app/calculators", label: "Calc", icon: Calculator, testId: "mobile-nav-calc" },
  { to: "/app/chat", label: "Chat", icon: MessageCircle, testId: "mobile-nav-chat" },
];

/**
 * Fixed bottom-tab-bar for mobile only (hidden ≥sm). Sits above the Kubernetes ingress /
 * keyboard on iOS via safe-area padding. Every page in `/app/*` reserves 76px of
 * bottom padding on mobile so content isn't hidden underneath (see `AppShell`).
 */
export function BottomTabBar() {
  const { pathname } = useLocation();
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 flex border-t border-border bg-bg/95 backdrop-blur-md sm:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-bottom-tab-bar"
      role="navigation"
      aria-label="Primary"
    >
      {TABS.map((tab) => {
        const active = tab.match ? tab.match(pathname) : pathname.startsWith(tab.to);
        const Icon = tab.icon;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            data-testid={tab.testId}
            aria-current={active ? "page" : undefined}
            className={`flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] transition-colors ${
              active ? "text-gold" : "text-muted hover:text-text"
            }`}
          >
            <Icon className={`h-5 w-5 ${active ? "text-gold" : ""}`} />
            <span className="font-medium">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}

export default BottomTabBar;
